/**
 *
 * AdminAssessmentTool
 *
 */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { createStructuredSelector } from 'reselect';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import _isEmpty from 'lodash/isEmpty';
import AppContainer from 'components/AppContainer';
import LoadingOverlay from 'components/LoadingOverlay';
import { toast } from 'react-toastify';
import Header from 'components/Header';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import { makeSelectProfile } from 'containers/Auth/selectors';
// import CopyModal from './components/CopyModal';
import SurveyEditor from './components/SurveyEditor';
import Table from './components/TableComponents/StyledTable';
import TableHeadCell from './components/TableComponents/StyledTableHeadCell';
import TableRow from './components/TableComponents/StyledTableRow';
import TableCell from './components/TableComponents/StyledTableCell';
import {
  makeSelectProcessing,
  makeSelectAdminAssessments,
  makeSelectResult,
} from './selectors';
import { getAdminAssessments, submitAdminAssessment } from './actions';
import reducer from './reducer';
import saga from './saga';

const useStyles = makeStyles({
  root: {
    marginTop: 18,
  },
  tableBody: {
    '& > tr > th:first-child': {
      width: '99%',
    },
  },
  topAction: {
    marginRight: 4,
    marginLeft: 4,
    '&:first-child': {
      marginLeft: 0,
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  action: {
    marginTop: 4,
    marginBottom: 4,
    width: '100%',
  },
  label: {
    textAlign: 'center',
  },
});

const stateSelector = createStructuredSelector({
  adminAssessments: makeSelectAdminAssessments(),
  result: makeSelectResult(),
  processing: makeSelectProcessing(),
  profile: makeSelectProfile(),
});

const AdminAssessmentTool = () => {
  useInjectReducer({ key: 'adminAssessment', reducer });
  useInjectSaga({ key: 'adminAssessment', saga });

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [copy, setCopy] = useState({});
  const [edit, setEdit] = useState(null);
  const { adminAssessments, result, processing, profile } = useSelector(
    stateSelector,
  );

  useEffect(() => {
    if (
      profile.isLoaded &&
      profile.role !== 'admin' &&
      profile.role !== 'contentAdmin'
    ) {
      history.push('/');
    }
  }, [profile]);

  useEffect(() => {
    if (result.error) {
      toast(result.message, { type: 'error' });
    } else {
      dispatch(getAdminAssessments());
      setEdit(null);
      if (!_isEmpty(copy)) {
        setCopy({});
      }
    }
  }, [result]);

  const onEditFinish = payload => {
    dispatch(submitAdminAssessment(payload));
  };

  // const handleCopy = data => {
  //   setCopy(data);
  // };

  // const handleClose = () => setCopy({});

  const content = () => {
    if (edit) {
      return (
        <>
          <Button
            variant="outlined"
            classes={{ root: classes.topAction }}
            onClick={() => setEdit(null)}
          >
            Back
          </Button>
          <SurveyEditor data={edit} onEditFinish={onEditFinish} />
        </>
      );
    }

    if (!_isEmpty(adminAssessments))
      return (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeadCell>Assessment</TableHeadCell>
              <TableHeadCell>Demographics QA</TableHeadCell>
              <TableHeadCell>Review Status</TableHeadCell>
              <TableHeadCell>Actions</TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {adminAssessments.map(row => (
              <TableRow>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.passed ? 'Passed' : 'Failed'}</TableCell>
                <TableCell>{row.reviewStatus}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    classes={{ root: classes.action, label: classes.label }}
                    onClick={() => setEdit(row)}
                  >
                    Edit JSON
                  </Button>
                  <Button
                    variant="outlined"
                    classes={{ root: classes.action, label: classes.label }}
                    component="a"
                    target="_blank"
                    rel="noopener"
                    href={`https://app.contentful.com/spaces/o6q5esfvflvg/entries/${row.id}`}
                  >
                    Edit in Contentful
                  </Button>
                  {/* <Button
                    variant="outlined"
                    classes={{ root: classes.action, label: classes.label }}
                    onClick={() => handleCopy(row)}
                  >
                    Copy English JSON
                  </Button> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      );

    return null;
  };

  return (
    <>
      <Header title="CredibleMind Assessments Tool" />
      <AppContainer>
        <LoadingOverlay show={processing} />
        <Grid container spacing={2}>
          {!edit && (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                classes={{ root: classes.topAction }}
                onClick={() => history.push('/admin')}
              >
                Exit
              </Button>
            </Grid>
          )}
          <Grid item xs={12}>
            {content()}
          </Grid>
        </Grid>
      </AppContainer>
      {/* <CopyModal data={copy} onSave={onEditFinish} onClose={handleClose} /> */}
    </>
  );
};

export default AdminAssessmentTool;
